import { ApplicationStep, StepbystepApplicationStep } from 'embed/constants'

/**
 * Co-Applicant related application steps
 */

export const defaultCoApplicantApplicationWithLoanPurpose: ApplicationStep[] = [
  StepbystepApplicationStep.LoanPurpose,
  StepbystepApplicationStep.LoanAmount,
  StepbystepApplicationStep.CreditRating,
  StepbystepApplicationStep.Email,
  StepbystepApplicationStep.DateOfBirth,
  StepbystepApplicationStep.Name,
  StepbystepApplicationStep.PropertyStatus,
  StepbystepApplicationStep.EducationLevel,
  StepbystepApplicationStep.Address,
  StepbystepApplicationStep.Phone,
  StepbystepApplicationStep.EmploymentStatus,
  StepbystepApplicationStep.AnnualIncome,
  StepbystepApplicationStep.PayFrequency,
  StepbystepApplicationStep.SocialSecurity,
  StepbystepApplicationStep.CoApplicantToggle,
]

export const defaultCoApplicantApplicationWithoutLoanPurpose: ApplicationStep[] = [
  StepbystepApplicationStep.LoanAmount,
  StepbystepApplicationStep.CreditRating,
  StepbystepApplicationStep.Email,
  StepbystepApplicationStep.DateOfBirth,
  StepbystepApplicationStep.Name,
  StepbystepApplicationStep.PropertyStatus,
  StepbystepApplicationStep.EducationLevel,
  StepbystepApplicationStep.Address,
  StepbystepApplicationStep.Phone,
  StepbystepApplicationStep.EmploymentStatus,
  StepbystepApplicationStep.AnnualIncome,
  StepbystepApplicationStep.PayFrequency,
  StepbystepApplicationStep.SocialSecurity,
  StepbystepApplicationStep.CoApplicantToggle,
]

export const coApplicantSelectedApplicationWithLoanPurpose: ApplicationStep[] = [
  StepbystepApplicationStep.LoanPurpose,
  StepbystepApplicationStep.LoanAmount,
  StepbystepApplicationStep.CreditRating,
  StepbystepApplicationStep.Email,
  StepbystepApplicationStep.DateOfBirth,
  StepbystepApplicationStep.Name,
  StepbystepApplicationStep.PropertyStatus,
  StepbystepApplicationStep.EducationLevel,
  StepbystepApplicationStep.Address,
  StepbystepApplicationStep.Phone,
  StepbystepApplicationStep.EmploymentStatus,
  StepbystepApplicationStep.AnnualIncome,
  StepbystepApplicationStep.PayFrequency,
  StepbystepApplicationStep.SocialSecurity,
  StepbystepApplicationStep.CoApplicantToggle,
  StepbystepApplicationStep.CoApplicantName,
  StepbystepApplicationStep.CoApplicantDateOfBirth,
  StepbystepApplicationStep.CoApplicantAnnualIncome,
  StepbystepApplicationStep.CoApplicantAddressMatch,
]

export const coApplicantSelectedApplicationWithoutLoanPurpose: ApplicationStep[] = [
  StepbystepApplicationStep.LoanAmount,
  StepbystepApplicationStep.CreditRating,
  StepbystepApplicationStep.Email,
  StepbystepApplicationStep.DateOfBirth,
  StepbystepApplicationStep.Name,
  StepbystepApplicationStep.PropertyStatus,
  StepbystepApplicationStep.EducationLevel,
  StepbystepApplicationStep.Address,
  StepbystepApplicationStep.Phone,
  StepbystepApplicationStep.EmploymentStatus,
  StepbystepApplicationStep.AnnualIncome,
  StepbystepApplicationStep.PayFrequency,
  StepbystepApplicationStep.SocialSecurity,
  StepbystepApplicationStep.CoApplicantToggle,
  StepbystepApplicationStep.CoApplicantName,
  StepbystepApplicationStep.CoApplicantDateOfBirth,
  StepbystepApplicationStep.CoApplicantAnnualIncome,
  StepbystepApplicationStep.CoApplicantAddressMatch,
]

/**
 * Non Co-Applicant related application steps
 */

export const defaultApplicationWithLoanPurpose: ApplicationStep[] = [
  StepbystepApplicationStep.LoanPurpose,
  StepbystepApplicationStep.LoanAmount,
  StepbystepApplicationStep.CreditRating,
  StepbystepApplicationStep.Email,
  StepbystepApplicationStep.DateOfBirth,
  StepbystepApplicationStep.Name,
  StepbystepApplicationStep.PropertyStatus,
  StepbystepApplicationStep.EducationLevel,
  StepbystepApplicationStep.Address,
  StepbystepApplicationStep.Phone,
  StepbystepApplicationStep.EmploymentStatus,
  StepbystepApplicationStep.AnnualIncome,
  StepbystepApplicationStep.PayFrequency,
  StepbystepApplicationStep.SocialSecurity,
]

export const defaultApplicationWithoutLoanPurpose: ApplicationStep[] = [
  StepbystepApplicationStep.LoanAmount,
  StepbystepApplicationStep.CreditRating,
  StepbystepApplicationStep.Email,
  StepbystepApplicationStep.DateOfBirth,
  StepbystepApplicationStep.Name,
  StepbystepApplicationStep.PropertyStatus,
  StepbystepApplicationStep.EducationLevel,
  StepbystepApplicationStep.Address,
  StepbystepApplicationStep.Phone,
  StepbystepApplicationStep.EmploymentStatus,
  StepbystepApplicationStep.AnnualIncome,
  StepbystepApplicationStep.PayFrequency,
  StepbystepApplicationStep.SocialSecurity,
]

export const slrWithLoanPurposeWithGraduateLevelApplication: ApplicationStep[] = [
  StepbystepApplicationStep.LoanPurpose,
  StepbystepApplicationStep.LoanAmount,
  StepbystepApplicationStep.CreditRating,
  StepbystepApplicationStep.Email,
  StepbystepApplicationStep.DateOfBirth,
  StepbystepApplicationStep.Name,
  StepbystepApplicationStep.PropertyStatus,
  StepbystepApplicationStep.MonthlyHousingPayment,
  StepbystepApplicationStep.EducationLevel,
  StepbystepApplicationStep.GraduateDegreeLevel,
  StepbystepApplicationStep.University,
  StepbystepApplicationStep.GraduationDate,
  StepbystepApplicationStep.Address,
  StepbystepApplicationStep.CitizenshipStatus,
  StepbystepApplicationStep.Phone,
  StepbystepApplicationStep.EmploymentStatus,
  StepbystepApplicationStep.AnnualIncome,
  StepbystepApplicationStep.PayFrequency,
  StepbystepApplicationStep.AvailableAssets,
  StepbystepApplicationStep.SocialSecurity,
]

export const slrWithLoanPurposeWithoutGraduateLevelApplication: ApplicationStep[] = [
  StepbystepApplicationStep.LoanPurpose,
  StepbystepApplicationStep.LoanAmount,
  StepbystepApplicationStep.CreditRating,
  StepbystepApplicationStep.Email,
  StepbystepApplicationStep.DateOfBirth,
  StepbystepApplicationStep.Name,
  StepbystepApplicationStep.PropertyStatus,
  StepbystepApplicationStep.MonthlyHousingPayment,
  StepbystepApplicationStep.EducationLevel,
  StepbystepApplicationStep.University,
  StepbystepApplicationStep.GraduationDate,
  StepbystepApplicationStep.Address,
  StepbystepApplicationStep.CitizenshipStatus,
  StepbystepApplicationStep.Phone,
  StepbystepApplicationStep.EmploymentStatus,
  StepbystepApplicationStep.AnnualIncome,
  StepbystepApplicationStep.PayFrequency,
  StepbystepApplicationStep.AvailableAssets,
  StepbystepApplicationStep.SocialSecurity,
]

export const slrWithoutLoanPurposeWithGraduateLevelApplication: ApplicationStep[] = [
  StepbystepApplicationStep.LoanAmount,
  StepbystepApplicationStep.CreditRating,
  StepbystepApplicationStep.Email,
  StepbystepApplicationStep.DateOfBirth,
  StepbystepApplicationStep.Name,
  StepbystepApplicationStep.PropertyStatus,
  StepbystepApplicationStep.MonthlyHousingPayment,
  StepbystepApplicationStep.EducationLevel,
  StepbystepApplicationStep.GraduateDegreeLevel,
  StepbystepApplicationStep.University,
  StepbystepApplicationStep.GraduationDate,
  StepbystepApplicationStep.Address,
  StepbystepApplicationStep.CitizenshipStatus,
  StepbystepApplicationStep.Phone,
  StepbystepApplicationStep.EmploymentStatus,
  StepbystepApplicationStep.AnnualIncome,
  StepbystepApplicationStep.PayFrequency,
  StepbystepApplicationStep.AvailableAssets,
  StepbystepApplicationStep.SocialSecurity,
]

export const slrWithoutLoanPurposeWithoutGraduateLevelApplication: ApplicationStep[] = [
  StepbystepApplicationStep.LoanAmount,
  StepbystepApplicationStep.CreditRating,
  StepbystepApplicationStep.Email,
  StepbystepApplicationStep.DateOfBirth,
  StepbystepApplicationStep.Name,
  StepbystepApplicationStep.PropertyStatus,
  StepbystepApplicationStep.MonthlyHousingPayment,
  StepbystepApplicationStep.EducationLevel,
  StepbystepApplicationStep.University,
  StepbystepApplicationStep.GraduationDate,
  StepbystepApplicationStep.Address,
  StepbystepApplicationStep.CitizenshipStatus,
  StepbystepApplicationStep.Phone,
  StepbystepApplicationStep.EmploymentStatus,
  StepbystepApplicationStep.AnnualIncome,
  StepbystepApplicationStep.PayFrequency,
  StepbystepApplicationStep.AvailableAssets,
  StepbystepApplicationStep.SocialSecurity,
]
